export default {
  apiKey: "AIzaSyA-IkYoBC3CTk36hYwAMp9RXK8sUNz_JAQ",
  authDomain: "githubdashboard-21513.firebaseapp.com",
  databaseURL: "https://githubdashboard-21513.firebaseio.com",
  projectId: "githubdashboard-21513",
  storageBucket: "githubdashboard-21513.appspot.com",
  messagingSenderId: "304438303869",
  appId: "1:304438303869:web:0637fbbc991c70b2312514",
  measurementId: "G-TTV3LSQ2RT"
  }; 


  